import { render, staticRenderFns } from "./PurchaseOrderDetailListV2.vue?vue&type=template&id=3a96f28a&"
import script from "./PurchaseOrderDetailListV2.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderDetailListV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports